// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-toolbar {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  flex-wrap: wrap;
}

.toolbar-button-wrapper {
  position: relative;
}

.toolbar-panel-anchor {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 200;
  /* min-width: 350px; */
}

.toolbar-panel-anchor-right {
  left: auto;
  right: 0;
}

.toolbar-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 40px;
  height: 40px;
  padding: 8px;
  border: 1px solid var(--color-brand);
  color: var(--color-brand);
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: var(--color-brand-hover2);
  }
}

.toolbar-button-active {
  width: auto;
  padding: 0 10px;
  background: var(--color-brand-hover2);
}

.chart-toolbar-mobile .toolbar-button-active {
  width: 40px;
  padding: 0;
}

.toolbar-button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.toolbar-button-icon svg {
  width: 20px;
  height: 20px;
}
.toolbar-button-icon svg path {
  fill: var(--color-brand);
}
.toolbar-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 14px;
  height: 14px;
  background: var(--color-brand);
  color: var(--surface-primary);
  border-radius: 7px;
  font-size: 9px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  pointer-events: none;
}

@container (max-width: 600px) {
  .chart-toolbar {
    margin-left: 0;
    flex-wrap: wrap;
  }

  .toolbar-button-active {
    width: 40px;
    padding: 8px;
  }

  .toolbar-button-active .header-4 {
    display: none;
  }

  .toolbar-button-wrapper {
    position: static;
  }

  .toolbar-panel-anchor,
  .toolbar-panel-anchor-right {
    position: absolute;
    top: 100%;
    left: auto;
    right: 13%;
    width: 85%;
    max-height: 60vh;
    z-index: 300;
    /* box-shadow: 0 0 12px var(--box-shadow-primary); */
    /* border: 1px solid var(--border-primary); */
    border-radius: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/Toolbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,oDAAoD;IACpD,6CAA6C;IAC7C,kBAAkB;EACpB;AACF","sourcesContent":[".chart-toolbar {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.toolbar-button-wrapper {\n  position: relative;\n}\n\n.toolbar-panel-anchor {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 200;\n  /* min-width: 350px; */\n}\n\n.toolbar-panel-anchor-right {\n  left: auto;\n  right: 0;\n}\n\n.toolbar-button {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 40px;\n  height: 40px;\n  padding: 8px;\n  border: 1px solid var(--color-brand);\n  color: var(--color-brand);\n  border-radius: 4px;\n  background: transparent;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  transition: all 0.2s ease-in-out;\n  &:hover {\n    background: var(--color-brand-hover2);\n  }\n}\n\n.toolbar-button-active {\n  width: auto;\n  padding: 0 10px;\n  background: var(--color-brand-hover2);\n}\n\n.chart-toolbar-mobile .toolbar-button-active {\n  width: 40px;\n  padding: 0;\n}\n\n.toolbar-button-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n}\n\n.toolbar-button-icon svg {\n  width: 20px;\n  height: 20px;\n}\n.toolbar-button-icon svg path {\n  fill: var(--color-brand);\n}\n.toolbar-badge {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  min-width: 14px;\n  height: 14px;\n  background: var(--color-brand);\n  color: var(--surface-primary);\n  border-radius: 7px;\n  font-size: 9px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 3px;\n  pointer-events: none;\n}\n\n@container (max-width: 600px) {\n  .chart-toolbar {\n    margin-left: 0;\n    flex-wrap: wrap;\n  }\n\n  .toolbar-button-active {\n    width: 40px;\n    padding: 8px;\n  }\n\n  .toolbar-button-active .header-4 {\n    display: none;\n  }\n\n  .toolbar-button-wrapper {\n    position: static;\n  }\n\n  .toolbar-panel-anchor,\n  .toolbar-panel-anchor-right {\n    position: absolute;\n    top: 100%;\n    left: auto;\n    right: 13%;\n    width: 85%;\n    max-height: 60vh;\n    z-index: 300;\n    /* box-shadow: 0 0 12px var(--box-shadow-primary); */\n    /* border: 1px solid var(--border-primary); */\n    border-radius: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
